import { AfterViewChecked, Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { InterfaceService } from 'src/app/services/interface.service';
import { NavigationService } from 'src/app/services/navigation.service';

@Component({
  selector: 'app-appraisers',
  templateUrl: './appraisers.component.html',
  styleUrls: ['./appraisers.component.scss'],
})
export class AppraisersComponent implements OnInit, AfterViewChecked {
  get currentLanguage() {
    return this.dataService.currentLanguage;
  }

  get generalTexts() {
    return this.dataService.generalTexts;
  }

  get currentData() {
    return this.dataService.data;
  }

  firstLoad = false;

  constructor(
    public navigationService: NavigationService,
    public interfaceService: InterfaceService,
    private dataService: DataService
  ) {}

  ngOnInit(): void {
    this.interfaceService.displayDark = true;
    this.interfaceService.footerBackgroundChange = true;

    this.interfaceService.reveal();
  }

  ngAfterViewChecked(): void {
    if (!this.firstLoad) {
      this.interfaceService.reveal();
      this.firstLoad = true;
    }
  }
}
